/*
 * TranscriptsFilter Messages
 *
 * This contains all the text for the TranscriptsFilter component.
 */
import { defineMessages } from 'react-intl';

const messages = {
  tableHeaderId: {
    id: 'DASHBOARD.tableHeaderId',
    defaultMessage: 'ID',
  },
  tableHeaderTitle: {
    id: 'DASHBOARD.tableHeaderTitle',
    defaultMessage: 'Title',
  },
  tableHeaderOrganization: {
    id: 'DASHBOARD.tableHeaderOrganization',
    defaultMessage: 'Client',
  },
  tableHeaderDuration: {
    id: 'DASHBOARD.tableHeaderDuration',
    defaultMessage: 'Duration',
  },
  tableHeaderFileName: {
    id: 'DASHBOARD.tableHeaderFileName',
    defaultMessage: 'File name',
  },
  tableHeaderDate: {
    id: 'DASHBOARD.tableHeaderDate',
    defaultMessage: 'Date',
  },
  tableHeaderCreationDate: {
    id: 'DASHBOARD.tableHeaderCreationDate',
    defaultMessage: 'Created',
  },
  tableHeaderStatus: {
    id: 'DASHBOARD.tableHeaderStatus',
    defaultMessage: 'Status',
  },
  tableHeaderAnalyst: {
    id: 'DASHBOARD.tableHeaderAnalyst',
    defaultMessage: 'Analyst',
  },
  tableHeaderPin: {
    id: 'ORGANISMS_TRANSCRIPTS.table_header_pin',
    defaultMessage: 'Pin',
  },
  tableHeaderView: {
    id: 'DASHBOARD.tableHeaderView',
    defaultMessage: 'View',
  },
  transcriptStatus_initial: {
    id: 'DASHBOARD.transcriptStatus_initial',
    defaultMessage: 'Transcript created',
  },
  transcriptStatus_uploaded: {
    id: 'DASHBOARD.transcriptStatus_uploaded',
    defaultMessage: 'Transcription in progress',
  },
  transcriptStatus_complete: {
    id: 'DASHBOARD.transcriptStatus_complete',
    defaultMessage: 'Transcript complete',
  },
  transcriptStatus_error: {
    id: 'DASHBOARD.transcriptStatus_error',
    defaultMessage: 'Error',
  },
  transcriptStatus_empty: {
    id: 'DASHBOARD.transcriptStatus_empty',
    defaultMessage: ' ',
  },
  transcriptStatus_done: {
    id: 'DASHBOARD.transcriptStatus_done',
    defaultMessage: 'Done',
  },
  transcriptStatus_talking: {
    id: 'DASHBOARD.transcriptStatus_talking',
    defaultMessage: 'Conference call in progress',
  },
  transcriptStatus_waiting: {
    id: 'DASHBOARD.transcriptStatus_waiting',
    defaultMessage: 'Waiting for attendees',
  },
  transcriptStatus_cancelled: {
    id: 'DASHBOARD.transcriptStatus_cancelled',
    defaultMessage: 'Cancelled',
  },
  transcriptStatus_expired: {
    id: 'DASHBOARD.transcriptStatus_expired',
    defaultMessage: 'Expired',
  },
  transcriptStatus_error_uploading: {
    id: 'DASHBOARD.transcriptStatus_error_uploading',
    defaultMessage: 'Error',
  },
  transcriptStatus_error_email_send: {
    id: 'DASHBOARD.transcriptStatus_error_email_send',
    defaultMessage: 'Error',
  },
  transcriptStatus_deleted: {
    id: 'DASHBOARD.transcriptStatus.deleted',
    defaultMessage: 'Transcript Deleted',
  },
};

export default defineMessages(messages);



// WEBPACK FOOTER //
// ./components/organisms/DashboardTable/messages.js